import Benefits from './Benefits';
import type { EmailContentProps } from './EmailContent';

const DefaultEmailContent = ({ requesterName, inviteeName, benefits }: EmailContentProps) => (
    <>
        Hello{inviteeName !== '' ? ` ${inviteeName}` : ''},<br />
        <br />
        You have received a new request for a partner connection
        {requesterName !== '' ? ` from "${requesterName}"` : ''}.
        <br />
        <br />
        Accepting the partner connection allows the following:
        <Benefits benefits={benefits} />
        <button type='button' className='btn btn-default btn-link btn-xs'>
            View connection request
        </button>
        <br />
        <br />
        To view and accept the request, you need a RIO account.
        <br />
        Do you don't have one yet?{' '}
        <button type='button' className='btn btn-default btn-link btn-xs'>
            Register now for free.
        </button>
    </>
);

export default DefaultEmailContent;
